<template>
    <v-container class="tw-border-b-2">
                    <v-row no-gutters>
                        <v-col cols="12" md="4">
                            <div v-show="!noname" class="tw-text-lg tw-text-secondary">{{ getNameForDisplay() }}</div>
                            <div class="tw-text-sm">{{ getLocationForDisplay() }}</div>
                            <div class="tw-text-sm tw-capitalize"><strong>{{ getAvailabilityForDisplay() }}</strong></div><!--ToDo: We need to calculate this-->
                            <div class="tw-text-sm" v-if="item.emails?.length">
                                <a :href="getEmailMailToLink()">{{ getEmailForDisplay() }}</a>
                            </div>
                            <div class="tw-text-sm">
                                <span v-for="(phone, phone_index) in item.telephones">
                                    <a :href="`tel:${$root.formatPhoneNumeric(phone.telephone_fax)}`">{{ getPhoneForDisplay(phone) }}</a>
                                    <span v-if="phone_index < (item.telephones.length - 1)"> | </span>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="tw-text-sm tw-capitalize"><strong>CATEGORY</strong></div>
                            <div class="tw-text-sm">
                                {{ getCategoriesForDisplay() }}
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="tw-text-sm" v-if="getWebsiteForDisplay()">
                                <a :href="getWebsiteForDisplay()" target="_blank" style="color: blue; text-decoration: underline;">Website</a>
                            </div>
                            <div class="tw-text-sm" v-if="getDemoReelForDisplay()">
                                <a :href="getDemoReelForDisplay()" target="_blank" style="color: blue; text-decoration: underline;">Demo Reel</a>
                            </div>
                            <div class="tw-text-sm" v-if="this.item.uploaded_resumes && this.item.uploaded_resumes.length > 0">
                                <a :href="getResumeForDisplay()" target="_blank" style="color: blue; text-decoration: underline;">Resume</a>
                            </div>

                        </v-col>
                    </v-row>
                </v-container>
</template>

<script>

    export default {
        name: "MembersListingItemDetails",
        props: {
            'item': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'noname': {
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                search: null,
            }
        },
        computed: {
            num_members_total() {
                return this.fetch_data_response?.data?.recordsTotal
            },
        },
        methods: {
            getNameForDisplay() {
                if (!!this.item?.last_name && !!this.item?.first_name) {
                    return `${this.item.last_name}, ${this.item.first_name}`
                }
                return this.item?.last_name || this.item?.first_name
            },
            getFullName() {
                if (!!this.item?.last_name && !!this.item?.first_name) {
                    return `${this.item.first_name} ${this.item.last_name}`
                }
                return this.item?.last_name || this.item?.first_name
            },
            getEmailForDisplay() {
                return this.item?.emails[0]?.email
            },
            getEmailMailToLink() {
                let email = this.item?.emails[0]?.email
                if (!email) return '#'
                let name = this.getFullName(this.item)
                // return `mailto:"${name}"<${email}>`
                return `mailto:${email}`
            },
            getPhoneForDisplay(phone_record) {
                if (phone_record?.type == 'f') return ''
                let phone = phone_record?.telephone_fax
                let type = phone_record?.type ? ` [${phone_record.type.toUpperCase()}]` : ''
                return `${phone}${type}`
            },
            getCategoriesForDisplay() {
                if (!this.item?.functions_active?.length) return ''
                let refined = this.item.functions_active.map((title) => title.function_name)
                return refined.join(', ')
            },
            getWebsiteForDisplay() {
                return this.item?.website
            },
            getDemoReelForDisplay() {
                return this.item?.demo_reel
            },
            getResumeForDisplay() {
                if (this.item.uploaded_resumes && this.item.uploaded_resumes.length > 0) {
                    const userId = this.item.id
                    const fileName = this.item.uploaded_resumes[0].file_name
                    return `/storage/user_resumes/${userId}/${fileName}`
                }
                return null
            },
            getLocationForDisplay() {
                if (!this.item?.addresses?.length) return null
                let city = this.item.addresses[0].city?.trim()
                let province = this.item.addresses[0].province?.name.trim()
                return (city && province) ? `${city}, ${province}` : (city || province)
            },
            getAvailabilityForDisplay() {
                return this.item?.availability_info
            },
        }
    }
</script>

<style>
</style>
